import React from "react";

const Header = () =>{
    return(
 <div className="header">
     <span className="font-link">
        <h1>Welcome!</h1>
        <h4>-Stick around and learn about some cool brewers and their great tasting beers-</h4>
        <h5>"Everyone needs to believe in something, and I believe I'll have another beer." -- George Washington (probably)</h5>
        <img className= "image1" alt="keg" src="https://images.pexels.com/photos/1267328/pexels-photo-1267328.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"/>
        <h4>Cheers!</h4>
     </span>
 </div>
    )
}

export default Header;